// src/components/ChatHeader.jsx
import dayjs from "dayjs";
import { Megaphone, Search, Info } from "lucide-react";
import { useAuthStore } from "../store/useAuthStore";
import { getUserColor, getInitials } from "../utils/avatarColor";
import "./ChatHeader.css";

const isAnnouncementId = (id = "") =>
  String(id).startsWith("group:announcements");

const formatLastSeen = (value) => {
  if (!value) return "Offline";
  const d = dayjs(value);
  if (!d.isValid()) return "Offline";

  const now = dayjs();
  if (d.isSame(now, "day")) return `last seen today at ${d.format("hh:mm A")}`;
  if (d.isSame(now.subtract(1, "day"), "day"))
    return `last seen yesterday at ${d.format("hh:mm A")}`;
  return `last seen ${d.format("DD/MM/YYYY")} at ${d.format("hh:mm A")}`;
};

export default function ChatHeader({ selectedUser, onSearch, onInfo }) {
  const onlineUsers = useAuthStore((s) => s.onlineUsers) || [];
  const socket = useAuthStore((s) => s.socket);

  if (!selectedUser) return <div className="ch" />;

  // DEBUG (baad mein hata denge)
  console.log("🔎 PRESENCE DEBUG", {
    selectedUserId: String(selectedUser._id),
    onlineUsers,
    socketConnected: socket?.connected,
    socketId: socket?.id,
  });

  const isAnnouncement = isAnnouncementId(selectedUser._id);

  const isOnline =
    !isAnnouncement &&
    onlineUsers.some(
      (id) => String(id?._id || id) === String(selectedUser._id),
    );

  const statusText = isAnnouncement
    ? "Company-wide updates"
    : isOnline
      ? "online"
      : formatLastSeen(selectedUser.lastSeen);

  const avatarClass = [
    "ch__avatar",
    isOnline ? "is-online" : "",
    isAnnouncement ? "is-group" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const avatarStyle =
    isAnnouncement || selectedUser.profilePic
      ? undefined
      : { backgroundColor: getUserColor(selectedUser._id) };

  return (
    <div className="ch">
      <div
        className={`ch__left ${onInfo ? "is-clickable" : ""}`}
        onClick={onInfo}
      >
        <div className="ch__avatar-wrap">
          <div className={avatarClass} style={avatarStyle}>
            {isAnnouncement ? (
              <Megaphone size={22} />
            ) : selectedUser.profilePic ? (
              <img src={selectedUser.profilePic} alt={selectedUser.name} />
            ) : (
              getInitials(selectedUser.name)
            )}
          </div>
          {isOnline && <span className="ch__dot" />}
        </div>

        <div className="ch__info">
          <div className="ch__name">{selectedUser.name}</div>
          <div className={`ch__status ${isOnline ? "is-online" : ""}`}>
            {!isAnnouncement && <span className="ch__status-dot" />}
            <span>{statusText}</span>
          </div>
        </div>
      </div>

      <div className="ch__actions">
        {onSearch && (
          <button
            className="ch__icon-btn"
            onClick={onSearch}
            title="Search in chat"
          >
            <Search size={19} />
          </button>
        )}
        {onInfo && (
          <button
            className="ch__icon-btn"
            onClick={onInfo}
            title="Media, links and docs"
          >
            <Info size={19} />
          </button>
        )}
      </div>
    </div>
  );
}
